<template>
    <div class="register-container">
        <van-nav-bar title="注册/Registration" left-arrow @click-left="back"></van-nav-bar>

        <Banner />

        <!-- setp -->
        <div class="step-wrap" v-if="configData.isQuestionnaire == '1'">
            <div class="step-item" :class="{ active: currentStep < 2 }">
                <div class="step-number" :style="primaryBg"> 1</div>
                <span :style="primaryColor">信息填写</span>
                <span :style="primaryColor">information</span>
            </div>
            <div class="step-line" :style="primaryBorder"></div>
            <div class="step-item" :class="{ active: currentStep == 2 }">
                <div class="step-number" :style="primaryBg" v-if="currentStep == 2"> 2</div>
                <div class="step-number" v-else> 2</div>
                <div :style="primaryColor" v-if="currentStep == 2">
                    <p style="text-align:center;">参观需求</p>
                    <p style="text-align:center;">questionnaire</p>
                </div>
                <div v-else>
                    <p style="text-align:center;">参观需求</p>
                    <p style="text-align:center;">questionnaire</p>
                </div>
            </div>
        </div>

        <!-- 基础信息 -->
        <template v-if="currentStep === 1">
            <van-form validate-first @submit="onFormNext" label-width="60px" class="form" ref="formRef">
                <div v-for="(item,index) in formAttr" :key="index">
                    <component :is="createComponent(item)" v-model="formData[item.name == 'username' ? 'name' : item.name]" :attr="item" />
                </div>
            </van-form>
        </template>

        <!-- 问题 -->
        <template v-if="currentStep === 2">
            <div class="question">
                <div class="question-list" v-for="(item, index) in questionList" :key="index">
                    <div class="question-title">
                        <i v-show="item.isMust === 'Y'">*</i>
                        {{ item.title }}
                    </div>
                    <div>
                        <!-- 单选 -->
                        <div class="checkbox" v-if="item.maxSelect === 1">
                            <van-radio-group v-model="item.check">
                                <div v-for="option in item.opt">
                                    <van-radio :name="option.id">{{ option.title }}</van-radio>

                                    <van-field v-if="option.isManual == 'Y' && showOther(option.id, item.check)" type="text" class="question-input" v-model="option.manual"
                                               placeholder="请输入其他（entry other）" />
                                </div>
                            </van-radio-group>
                        </div>
                        <template v-else>
                            <!-- 多选-->
                            <div class="question-item" v-for="option in item.opt" :key="option.id">
                                <div class="checkbox">
                                    <van-checkbox v-model="option.check" shape="square" icon-size="16px" @change="OnChenkBox(item, option)">{{ option.title }}</van-checkbox>
                                </div>
                                <van-field v-if="option.isManual == 'Y' && option.check" type="text" class="question-input" v-model="option.manual" placeholder="请输入其他（entry other）" />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>

        <!-- 声明 -->
        <div class="agree" v-if="hasAggress">
            <div class="agree-txt">
                <div class="check">
                    <van-checkbox v-model="aggress" shape="square" icon-size="14px"></van-checkbox>遵守法律条款及协议
                </div>

                <p @click="onAgree">《用户须知》</p>
            </div>
        </div>

        <!-- 提交 -->
        <div class="submit" v-if="currentStep == 1">
            <van-button block round type="info" class="btn" :disabled="isClicked" :style="[primaryBorder,primaryBg]" @click="OnSubmit()">{{submitText}}</van-button>
        </div>
        <div class="submit" v-else>
            <van-button style="margin-right: 10px" block round type="info" class="btn" color="#999" @click="currentStep = 1">返回修改（Return）</van-button>
            <van-button block round type="info" class="btn" :disabled="isClicked" :style="primaryBg" @click="OnSubmit()">下一步（Next）</van-button>
        </div>

        <!-- 声明 -->
        <van-popup v-model="agreementShow" position="bottom" :style="{ height: '100%' }">
            <div class="popup-content">
                <div class="dialog-box" v-html="configData.hint"></div>

                <div class="agree-btn" :style="primaryBg">
                    <p @click="agreementShow = false">关闭</p>
                </div>
            </div>

        </van-popup>

        <van-popup v-model="areaShow" position="bottom">
            <van-area title="地址" :area-list="areaList" value="430100" @confirm="onConfirm" @cancel="onCancel" />
        </van-popup>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import UploadAvatar from '../../components/UploadAvatar';
import Toast from 'vant/lib/toast';
import httpRequest from '@/module_visitor/api/http.js';
import { mapGetters } from 'vuex';
import Banner from '@/components/Common/banner';
import { Dialog } from 'vant';
import areaList from '@/utils/area';
import QBlank from '@/components/FormItem/DefaultInput';
import QRadio from '@/components/FormItem/QRadio';
import QCheck from '@/components/FormItem/QCheck';
import QAvatar from '@/components/FormItem/QAvatar';
import QArea from '@/components/FormItem/QArea';
export default {
    data() {
        return {
            areaList: areaList,
            formAttr: [],
            RemarkCheckList: [],
            RegSourceList: [],
            currentStep: 1,
            aggress: false,
            hasAggress: false,
            agreementShow: false,
            configData: {},
            formData: {
                tel: '',
                name: '',
                position: '',
            },
            isClicked: false,
            areaShow: false,
            questionList: [],
            answersList: [],
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
        primaryBg() {
            return { background: this.defaultInfo.config.primaryColor };
        },
        primaryColor() {
            return { color: this.defaultInfo.config.primaryColor };
        },
        primaryBorder() {
            return { borderColor: this.defaultInfo.config.primaryColor };
        },
        submitText() {
            return this.configData.isQuestionnaire == 1 ? '下一步（Next）' : '提交（Submit）';
        },
    },
    created() {
        const { config } = this.defaultInfo;
        if (config.formAttr) {
            let json2 = eval('(' + config.formAttr + ')');
            let json3 = json2.zh.sort((a, b) => a.sort - b.sort).filter(it => it.display == 1);
            json3 = json3.filter(it => it.name != 'tel');
            json3.map(it => {
                if (it.name == 'idcard') {
                    it.title = '证件号';
                    it.message = it.description = '请填写证件号';
                    it.validator = '';
                }
            });

            this.formAttr = json3;
        }
        this.configData = config;

        // 提示
        if (config.hint && config.hint != '<p><br></p>') {
            this.hasAggress = true;
        }
        this.handleGetQuestion();
        this.formData.companyShareId = this.$route.query.companyShareId;
        this.formData.teamId = this.$route.query.teamId;
        this.formData.companyId = this.$route.query.companyId;
        this.formData.tel = this.$route.query.tel;
        this.formData.email = this.$route.query.email;
        this.formData.inviteId = this.$route.query.source;
        this.formData.idCardType = '观众证';
        this.formData.identitys = '1';
    },

    components: {
        Banner,
        UploadAvatar,
        QBlank,
        QRadio,
        QCheck,
        QAvatar,
        QArea,
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        createComponent(item) {
            return item.type;
        },
        onConfirm(val) {
            this.areaShow = false;
            this.formData.area = val[0].name + ' ' + val[1].name + ' ' + val[2].name;
        },
        onCancel() {
            this.areaShow = false;
        },

        onAgree() {
            this.agreementShow = true;
        },
        UploadPhoto(value) {
            this.formData.photo = value;
        },

        /** 问卷 ======================================== */

        showOther(list, id) {
            return list === id;
        },
        handleGetQuestion() {
            httpRequest.get(`/api/question/getQuestion`).then(res => {
                let data = res.data.data;
                if (res.data.code == 200) {
                    this.questionList = data;
                    this.questionList.forEach(it => {
                        this.$set(it, 'check', '');
                        it.opt.forEach(op => {
                            this.$set(op, 'check', false);
                        });
                    });
                }
            });
        },

        validateAnswer() {
            var model = [];
            try {
                this.questionList.forEach(item => {
                    // 多选
                    if (item.maxSelect > 1) {
                        item.opt.filter(o => {
                            let Question = {};
                            if (o.check && o.other && o.manual == null) {
                                Dialog.alert({
                                    title: '提示',
                                    message: `请回答${item.title}的${o.title}`,
                                });
                                throw 'break';
                            }
                            if (o.check) {
                                Question.questionId = item.id;
                                Question.answerId = o.id;
                                Question.isManual = o.isManual;
                                Question.check = o.check;
                                Question.manual = o.manual;
                                Question.answerContent = o.manual ? o.title + '【' + o.manual + '】' : o.title;
                                Question.visitiorName = this.formData.name;
                                Question.questionContent = item.title;
                                Question.tel = this.formData.tel;
                                model.push(Question);
                            }
                        });
                        if (item.isMust == 'Y') {
                            let isCheck = 0;
                            model.map(m => {
                                if (m.questionId == item.id) {
                                    if (m.isManual == 'Y' && m.manual == '') {
                                        isCheck = 2;
                                    } else {
                                        isCheck = 1;
                                    }
                                }
                                if (m.isManual == 'Y' && m.manual == '') {
                                    isCheck = 2;
                                }
                            });

                            if (isCheck === 0) {
                                Toast(`请选择（select）${item.title}`);
                                throw 'break';
                            }
                            if (isCheck === 2) {
                                Toast(`补充（supplement）${item.title} `);
                                throw 'break';
                            }
                        }
                    } else {
                        // 单选

                        if (item.check) {
                            const o = item.opt.filter(op => {
                                return op.id == item.check;
                            });

                            let q = {};
                            q.questionId = item.id;
                            q.answerId = item.id;
                            q.isManual = o[0].isManual;
                            q.manual = o[0].manual;
                            q.check = item.check;
                            q.answerContent = o[0].manual ? o[0].title + '【' + o[0].manual + '】' : o[0].title;
                            q.visitiorName = this.formData.name;
                            q.questionContent = item.title;
                            q.tel = this.formData.tel;
                            model.push(q);
                        }

                        if (item.isMust == 'Y') {
                            let isCheck = 0;
                            model.map(m => {
                                if (m.questionId == item.id) {
                                    if (m.isManual == 'Y' && m.manual == '') {
                                        isCheck = 2;
                                    } else {
                                        isCheck = 1;
                                    }
                                }
                            });
                            console.log(isCheck);
                            if (isCheck == 0) {
                                Toast(`请选择（select）${item.title}`);
                                throw 'break';
                            }
                            if (isCheck == 2) {
                                Toast(`补充（supplement）${item.title} `);
                                throw 'break';
                            }
                        }
                    }
                });
                this.answersList = model;

                return true;
            } catch (e) {
                console.error(e);
                return false;
            }
        },

        OnChenkBox(item, option) {
            if (option.isManual == 'Y') {
                option.other = true;
            }
        },

        // 注册
        handleRegister(model) {
            this.isClicked = true;
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
            });
            httpRequest
                .post(`/api/visitor/register`, model)
                .then(res => {
                    const { code, data, msg } = res.data;
                    if (code == 200) {
                        Toast('登记成功');
                        window.localStorage.setItem('v_token', data);
                        this.$router.push({ path: '/' });
                    } else {
                        Toast(msg);
                    }
                })
                .catch(error => {})
                .finally(() => {
                    Toast.clear();
                    this.isClicked = false;
                });
        },

        changeCheckBox(key, value) {
            this.formData[key] = this[value].join(',');
        },

        OnSubmit() {
            if (this.configData.hint && this.configData.hint != '<p><br></p>') {
                if (this.aggress == false) {
                    Toast('请勾选用户协议');
                    return;
                }
            }
            // this.$refs.formRef.validate().then(() => {
            //     console.log(this.formData);
            // });

            // return;

            // 有问卷
            if (this.currentStep === 2) {
                if (this.validateAnswer()) {
                    this.params = {
                        ...this.formData,
                        answers: this.answersList,
                    };

                    this.handleRegister(this.params);
                }

                return;
            }

            // 没有问卷

            this.$refs.formRef
                .validate()
                .then(() => {
                    this.params = {
                        ...this.formData,
                        answers: this.answersList,
                    };
                    // 下一步
                    if (this.currentStep === 1) {
                        if (this.configData.isQuestionnaire == 1) {
                            this.currentStep = 2;
                        } else {
                            this.handleRegister(this.params);
                        }
                        return;
                    }
                })
                .catch(err => {
                    console.log('err', err);
                    var errMsg = err[0].message;
                    this.$toast(errMsg);
                });
        },

        // 表单提交
        onFormNext(form) {
            if (form == null) {
                return;
            }

            this.params = {
                ...form,
                answers: [],
            };

            if (!form.Photo) {
                Toast('请上传您的头像');
                return;
            }

            if (!this.aggress) {
                Toast('请勾选用户协议');
                return;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.register-container {
    width: 100%;
    min-height: 100%;
    .step-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-top: 24px;
        .step-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            &.active {
                .step-number {
                    background: var(--theme_bg_color);
                    color: #fff;
                }
                span {
                    color: var(--theme_primary_color);
                }
            }
            .step-number {
                width: 25px;
                height: 25px;
                line-height: 25px;
                background: #999;
                color: #fff;
                border-radius: 25px;
                text-align: center;
            }
            span {
                font-size: 14px;
                margin-top: 4px;
            }
        }
        .step-line {
            width: 100px;
            height: 1px;
            margin-bottom: 12px;
            border-bottom: 2px dotted var(--theme_primary_color);
        }
        .step-item {
            .step-number {
            }
            span {
            }
        }
    }
    .form-item {
    }
    .question {
        padding: 0 10px;
        background: #fff;
        margin: 0 10px;

        .question-list {
            background: #fff;
            padding: 8px 15px;
            border: 1px solid #dbdbdb;
            border-radius: 10px;
            margin-top: 20px;
            ::v-deep .van-radio {
                padding: 4px 0px;
            }
            .question-title {
                font-weight: 600;
                padding: 12px 0;
                i {
                    color: #f00;
                }
            }

            .question-item {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                padding: 4px 0;
            }
            .question-input {
                width: 100%;
                outline: none;
                border: none;
                border: 1px solid #eaeaea;
            }
        }
    }
    .agree {
        .agree-txt {
            font-size: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
            height: 44px;
            .check {
                display: flex;
                align-items: center;
                font-weight: bold;
                & > div {
                    margin-right: 15px;
                }
            }

            p {
                color: #297d7f;
            }
        }
    }

    .form {
        padding: 20px;

        .form-border {
            background: #fff;
            padding: 5px;
            border: 1px solid #dbdbdb;
            border-radius: 10px;
            margin-top: 20px;
        }

        .form-title {
            font-size: 32px;
            position: relative;
            padding: 10px 32px;
            color: #323233;
            font-size: 14px;
            &::after {
                position: absolute;
                left: 8px;
                color: #ee0a24;
                font-size: 14px;
                content: '*';
            }
        }

        .form-require {
            position: relative;
            width: 10px;
        }
        .form-content {
            padding: 10px;
        }
    }
    .submit {
        .btn {
        }
    }

    .ql-snow {
    }

    .popup-content {
        padding: 20px;
        box-sizing: border-box;

        .dialog-box {
            padding: 24px;

            p {
                padding: 4ex;
            }
        }
        .ql-editor {
        }

        img {
            width: 100%;
        }
    }
    .agree-btn {
        width: 300px;
        line-height: 40px;
        height: 40px;
        color: #fff;
        text-align: center;
        border-radius: 12px;
        margin: 10px auto;
        p {
        }
    }
    .submit {
        padding: 20px 40px 60px;
        display: flex;
        justify-content: space-between;
        .btn {
        }
        .van-button {
            background: var(--theme_bg_color);
            color: #fff;
        }
    }

    .dialog {
        margin-bottom: 20px;
    }
}
</style>
